var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"toaster"}},[_c('v-snackbar',{attrs:{"color":_vm.toast.color,"timeout":3000,"bottom":""},model:{value:(_vm.toast.enable),callback:function ($$v) {_vm.$set(_vm.toast, "enable", $$v)},expression:"toast.enable"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.toast.message?_vm.toast.message:'Something went Wrong')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }